var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('span',{on:{"click":_vm.getExtraInfo}},[_c('i',{staticClass:"fa fa-asterisk mr-3 my-auto",style:({verticalAlign: 'middle', cursor: 'pointer', visibility: (_vm.visible) ? 'visible' : 'hidden'}),attrs:{"title":this.$lang('Dodatkowe informacje o bibliotece'),"data-toggle":"modal","data-target":"#show-extra-info-modal"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }